/** The items table's columns. */
import type { ObjEntity } from "../../api/types.gen.ts";

/** The entity's fields as columns, less `hide`: the ones shown on the table, or (none marked) all of them. */
export function columnsOf(entity: ObjEntity | undefined, hide: string | undefined) {
  const fields = (entity?.fields ?? []).filter((f) => f.key !== hide);
  return fields.some((f) => f.show_on_table) ? fields.filter((f) => f.show_on_table) : fields;
}

/** How many of the items table's columns are between the title's and the last change's (where folders have nothing). */
export function columnsBetween(entity: ObjEntity | undefined, emails: boolean): number {
  // Attachments, issues, (sender, recipients, sent), the entity's fields, reviewed.
  return 3 + (emails ? 3 : 0) + (entity ? columnsOf(entity, undefined).length : 0);
}
